import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiHelpCircle, FiChevronDown, FiMessageCircle, FiMail, FiExternalLink } from 'react-icons/fi';
import Header from './Header';
import '../styles/HelpCenterPage.css';

const HelpCenterPage = () => {
  const [expandedFaq, setExpandedFaq] = useState(null);

  const faqs = [
    {
      question: 'How do I send tokens on different chains?',
      answer: 'To send tokens, select your desired chain (TON or BNB) from the network selector, click the "Send" button, enter the recipient\'s wallet address and the amount. Make sure the recipient address matches the selected chain format. Review the transaction details and confirm to complete the transfer.'
    },
    {
      question: 'What is a recovery phrase?',
      answer: 'A recovery phrase is a unique 12-word combination that secures both your TON and BNB wallets. This single phrase can restore access to all your chains. Keep it safe and never share it with anyone. Store it offline in a secure location.'
    },
    {
      question: 'How do I secure my multi-chain wallet?',
      answer: 'Enable biometric authentication, use a strong PIN, and never share your recovery phrase. Since your wallet manages multiple chains (TON and BNB), it\'s crucial to double-check network selection when making transactions. Enable auto-lock and verify addresses carefully.'
    },
    {
      question: 'What are the transaction fees for each chain?',
      answer: 'Transaction fees vary by chain: TON typically has very low fees, while BNB (BSC) fees are paid in BNB. The exact fee depends on network conditions and transaction complexity. You\'ll see the applicable network fee before confirming any transaction.'
    },
    {
      question: 'How do I switch between chains?',
      answer: 'Use the network selector at the top of the screen to switch between TON and BNB chains. Your wallet address will update automatically to show the correct format for the selected network. Always verify you\'re on the correct chain before making transactions.'
    }
  ];

  return (
    <div className="page-container">
      <Header title="Help Center" />
      
      <div className="page-content">
        <motion.div 
          className="card help-card"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <div className="help-header">
            <div className="header-icon">
              <FiHelpCircle />
            </div>
            <h2>Frequently Asked Questions</h2>
            <p>Find answers to common questions about using your wallet</p>
          </div>

            <div className="faq-list">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  className="faq-item"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <button
                  className="faq-question"
                    onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                  >
                    <span>{faq.question}</span>
                  <motion.div
                    className="chevron"
                    animate={{ rotate: expandedFaq === index ? 180 : 0 }}
                  >
                    <FiChevronDown />
                  </motion.div>
                  </button>
                  <AnimatePresence>
                    {expandedFaq === index && (
                      <motion.div
                        className="faq-answer"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        {faq.answer}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
          </div>

          <div className="contact-section">
            <h3>Need More Help?</h3>
            <div className="contact-options">
              <a href="https://t.me/wallet_support" target="_blank" rel="noopener noreferrer" className="contact-button">
                <FiMessageCircle />
                <span>Chat Support</span>
                <FiExternalLink />
              </a>
              <a href="mailto:support@multichain.wallet" className="contact-button">
                <FiMail />
                <span>Email Support</span>
                <FiExternalLink />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default HelpCenterPage; 